export enum UserLanguages {
	EN_US = 'en-US',
	PT_BR = 'pt-BR',
	ES_ES = 'es-ES',
}

export type ILanguage = Record<UserLanguages, string>

export enum UserRole {
	ADMIN = 'admin',
	USER = 'user',
}

export interface IUser {
	_id: string
	email: string
	phone?: string
	role: UserRole
	updatedAt: string
	createdAt: string
	deactivatedAt?: string
	address: {
		street?: string
		city?: string
		state?: string
		zipCode?: string
		country?: string
	}
	personalInfo: {
		firstName: string
		lastName: string
		birthdate?: string
		document: {
			type?: string
			number?: string
			country?: string
		}
	}
	firebaseToken?: string | null
	config: {
		lang: UserLanguages
		location: string
	}
	hasSubscription: boolean
	isApplicationOwner: boolean
	plan: IPlan
	subscription: ISubscription
	modals: {
		onboarding: string[]
	}
}
